var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSeeds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.299 37.6987C32.4305 37.0914 32.5425 36.4789 32.6344 35.862C33.4198 30.6979 32.9459 25.4206 31.2531 20.4792C29.9637 16.6132 27.9638 13.0333 25.3662 9.91913C26.9368 8.08637 28.7473 6.46141 30.7555 5.09116C34.1546 2.75406 38.1055 1.34564 42.2167 1.00542C42.5689 0.9783 42.9214 1.05334 43.232 1.22154C43.5427 1.38973 43.7982 1.64395 43.9679 1.9537C45.9346 5.55806 46.9335 9.61049 46.8674 13.7158C46.7827 18.1732 45.6232 22.5442 43.4873 26.4575C41.3948 30.3801 38.3837 33.7377 34.7113 36.2435C33.9344 36.7777 33.1288 37.2633 32.299 37.6987Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6264 22.0433C28.0703 26.2481 28.4746 30.74 27.8049 35.1352C27.198 39.2154 25.5355 43.0663 22.9822 46.3063C22.7994 46.5371 22.5639 46.7206 22.2954 46.8414C21.9219 47.0076 21.5036 47.0444 21.1068 46.946C17.1155 45.9285 13.4594 43.8858 10.5008 41.0204C7.30505 37.9256 4.90132 34.107 3.49276 29.8873C2.04891 25.6825 1.64456 21.1906 2.31428 16.7954C2.92118 12.7152 4.58366 8.86431 7.13701 5.62425C7.35722 5.34807 7.65243 5.14126 7.98722 5.02863C8.32202 4.916 8.68219 4.90233 9.02455 4.98925C13.0024 6.00706 16.6485 8.03835 19.6072 10.885C22.811 13.9853 25.2189 17.8131 26.6264 22.0433Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSeeds);
export default __webpack_public_path__ + "static/media/icon_seeds.f7b2e89c0dfb389acd7d6203814dcd76.svg";
export { ForwardRef as ReactComponent };